import { ItemMedia } from "@/app/item/view/item-media"
import { PriceInCrypto } from "@/app/price"
import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { Trans, useLingui } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"

export function NftMiniature({ nft }: { nft: NftSearchItem }) {
  const { t } = useLingui()

  return (
    <div className="flex w-full items-center gap-3">
      <div className="relative aspect-square w-8 flex-shrink-0 overflow-hidden rounded-sm">
        <ItemMedia
          src={nft.image}
          alt={`Image for ${nft.name} item`}
          className="object-contain"
        />
      </div>
      <div className="flex flex-col overflow-hidden">
        <span className="overflow-hidden text-ellipsis text-nowrap">
          {nft.name}
        </span>
        <span className="text-foreground/60 text-xs">
          {nft.price ? (
            <>
              <Trans>Listed:</Trans> <PriceInCrypto {...nft.price} />
            </>
          ) : (
            <Trans>Not Listed</Trans>
          )}
        </span>
      </div>
    </div>
  )
}

export function NftMiniatureSkeleton() {
  return (
    <div className="flex w-full items-center gap-3">
      <Skeleton className="h-8 w-8" />
      <div className="flex flex-col">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  )
}
